(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.announcementBar = document.querySelector('[id^="AnnouncementBar-"]');
      this.setHeights();
      window.addEventListener('resize', this.setHeights.bind(this));
      window.addEventListener('load', this.setHeights.bind(this));
    }
    setHeights() {
      const headerHeight = this.header ? this.header.offsetHeight : 0;
      const announcementHeight = this.announcementBar ? this.announcementBar.offsetHeight : 0;
      document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
      document.documentElement.style.setProperty('--announcement-height', `${announcementHeight}px`);
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-banner"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.banner__slideshow').forEach(function (slideshow) {
      var slides = slideshow.querySelectorAll('.banner__slide');
      if (slides.length <= 1) return;

      var current = 0;
      var intervalId = setInterval(advanceSlide, 5000);

      function advanceSlide() {
        slides[current].classList.remove('is-active');
        current = (current + 1) % slides.length;
        slides[current].classList.add('is-active');
      }

      // Pause the slideshow while the tab is hidden, resume when visible again
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) {
          clearInterval(intervalId);
        } else {
          intervalId = setInterval(advanceSlide, 5000);
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rewaayat-hero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.rewaayat-hero').forEach(function (hero) {
      var slides = hero.querySelectorAll('.rewaayat-hero__slide');
      if (slides.length <= 1) return;

      var current = 0;
      var intervalId = setInterval(advanceSlide, 5000);

      function advanceSlide() {
        slides[current].classList.remove('is-active');
        current = (current + 1) % slides.length;
        slides[current].classList.add('is-active');
      }

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) {
          clearInterval(intervalId);
        } else {
          intervalId = setInterval(advanceSlide, 5000);
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
